"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGenericPasteProcessingConverter = void 0;

var _parseHTML = _interopRequireDefault(require("../utils/parseHTML"));

var _dom = require("../utils/dom");

function transformNode(node, formatTransformMap, clearAllStyles, defaultStylesMap) {
  var newNode = node; // Transform the node type

  if (formatTransformMap[node.nodeName]) {
    newNode = document.createElement(formatTransformMap[node.nodeName]);
    node.childNodes.forEach(function (child) {
      return newNode.appendChild(child.cloneNode(true));
    });
    node.parentNode.replaceChild(newNode, node);
  } // Clear node of all inline styles and classes


  if (clearAllStyles && newNode.style) {
    newNode.removeAttribute('style');
    newNode.removeAttribute('class');
  } // Replace newlines with <br> in pre tags


  if (newNode.nodeName === 'PRE') {
    var html = newNode.innerHTML.replace(/\r?\n/g, '<br />');
    newNode.innerHTML = html;
  } // Add default styles of node


  if (defaultStylesMap[newNode.nodeName]) {
    newNode.setAttribute('style', (0, _dom.serializeStyles)(defaultStylesMap[newNode.nodeName]));
  }

  newNode.childNodes.forEach(function (child) {
    return transformNode(child, formatTransformMap, clearAllStyles, defaultStylesMap);
  });
  return newNode;
}

var getGenericPasteProcessingConverter = function getGenericPasteProcessingConverter() {
  var formatTransformMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var clearAllStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var defaultStylesMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (html) {
    if (Object.keys(formatTransformMap).length || clearAllStyles || Object.keys(defaultStylesMap).length) {
      var doc = (0, _parseHTML.default)(html);
      doc.childNodes.forEach(function (node) {
        return transformNode(node, formatTransformMap, clearAllStyles, defaultStylesMap);
      });
      return doc.outerHTML;
    }

    return html;
  };
};

exports.getGenericPasteProcessingConverter = getGenericPasteProcessingConverter;